import { BusinessRegistrationService } from '../../../_services';
import { resolveApiErrorMessage } from '../../../_helpers/apiResponse';
import {
  BR_STATUS,
  getBrBusinessRegistrationId,
  getItemStatusCode,
  resolveBrDisplayStatus,
} from '../utils/brDocument';

/**
 * 驳回卡「取消」→ SoftDeleteDocument（供应商 / 管理端共用）。
 * 宿主覆盖：buildSoftDeletePayload、afterCancelRejectedSuccess。
 */
export default {
  data() {
    return {
      showCancelConfirm: false,
      cancelTargetId: null,
      cancelProcessingId: null,
    };
  },
  methods: {
    buildSoftDeletePayload(businessRegistrationId) {
      return { businessRegistrationId };
    },
    async afterCancelRejectedSuccess() {
      // 由页面覆盖：刷新列表 / 清缓存 / 成功 toast
    },
    handleCancel(item) {
      if (!item || this.cancelProcessingId != null || this.showCancelConfirm) {
        return;
      }
      const statusCode = getItemStatusCode(item);
      const isRejected = resolveBrDisplayStatus(item) === BR_STATUS.REJECTED
        || statusCode === BR_STATUS.REJECTED;
      if (!isRejected) {
        return;
      }
      const businessRegistrationId = getBrBusinessRegistrationId(item);
      if (!businessRegistrationId) {
        this.$toast?.error?.(this.$t('lbl_EMPBE_BR_Cancel_Failed'));
        return;
      }
      this.cancelTargetId = businessRegistrationId;
      this.showCancelConfirm = true;
    },
    closeCancelConfirm() {
      if (this.cancelProcessingId != null) {
        return;
      }
      this.showCancelConfirm = false;
      this.cancelTargetId = null;
    },
    async confirmCancelSubmission() {
      const businessRegistrationId = this.cancelTargetId;
      if (!businessRegistrationId || this.cancelProcessingId != null) {
        return;
      }
      this.cancelProcessingId = businessRegistrationId;
      try {
        const res = await BusinessRegistrationService.SoftDeleteDocument(
          this.buildSoftDeletePayload(businessRegistrationId),
        );
        if (!res?.isSuccessful) {
          this.$toast?.error?.(resolveApiErrorMessage(res) || this.$t('lbl_EMPBE_BR_Cancel_Failed'));
          return;
        }
        this.showCancelConfirm = false;
        this.cancelTargetId = null;
        await this.afterCancelRejectedSuccess();
      } catch (e) {
        this.$toast?.error?.(e?.message || this.$t('lbl_EMPBE_BR_Cancel_Failed'));
      } finally {
        this.cancelProcessingId = null;
      }
    },
  },
};
